export default __webpack_public_path__ + "static/media/List-documentation.98a9b2ea.md";